import org  from './organization'
import api from './api'

export default { api,org }
